import { render, staticRenderFns } from "./PackageKidsApproved.vue?vue&type=template&id=60842742&scoped=true"
import script from "./PackageKidsApproved.vue?vue&type=script&lang=js"
export * from "./PackageKidsApproved.vue?vue&type=script&lang=js"
import style0 from "./PackageKidsApproved.vue?vue&type=style&index=0&id=60842742&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60842742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60842742')) {
      api.createRecord('60842742', component.options)
    } else {
      api.reload('60842742', component.options)
    }
    module.hot.accept("./PackageKidsApproved.vue?vue&type=template&id=60842742&scoped=true", function () {
      api.rerender('60842742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidsApproved.vue"
export default component.exports